//Built-In
import React, {Fragment} from 'react';
import PreviewBox from "./PreviewBox";

//External
//Internal
export default class PreviewPanel extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {

        let { source, components, waComponents, formData, previewData } = this.props;

        return (
            <Fragment>
                <div className={'preview-panel preview-padding'}>
                    <h3>Preview</h3>
                    <div className={'preview-content'}>
                        <PreviewBox components={components} previewData={previewData} waComponents={waComponents} formData={formData} source={source} />
                    </div>
                </div>
            </Fragment>
        )
    }
}
